<template>
  <div class="msg-panel">
    <!-- 头部 -->
    <div class="msg-header">
      <span class="msg-title">消息通知</span>
      <div class="msg-header-actions">
        <el-button type="text" size="mini" class="action-btn" @click="handelallread">全部已读</el-button>
        <router-link to="/mymessage">
          <el-button type="text" size="mini" class="action-btn">查看全部</el-button>
        </router-link>
      </div>
    </div>

    <!-- 消息列表 -->
    <div v-loading="tableloading" class="msg-list">
      <div v-if="messages.length === 0 && !tableloading" class="msg-empty">
        <i class="el-icon-bell" style="font-size:32px;color:#ddd;" />
        <p>暂无消息</p>
      </div>

      <div
        v-for="item in messages"
        :key="item.ID"
        class="msg-item"
        :class="{ unread: !item.IsRead }"
        @click="!item.IsRead && handleRead([item.ID])"
      >
        <div class="msg-dot" v-if="!item.IsRead" />
        <div class="msg-content">
          <p class="msg-text">{{ item.MessageStr }}</p>
          <span class="msg-time">{{ formatTime(item.CreatedAt) }}</span>
        </div>
        <el-tag v-if="item.IsRead" size="mini" type="info" class="msg-tag">已读</el-tag>
      </div>
    </div>

    <!-- 分页 -->
    <div class="msg-footer">
      <el-pagination
        small
        layout="prev, pager, next"
        :current-page="currentPage"
        :page-size="pageSize"
        :total="total"
        @current-change="handleCurrentChange"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: 'MessagePanel',
  data() {
    return {
      tableloading: false,
      messages: [],
      currentPage: 1,
      pageSize: 8,
      total: 0
    }
  },
  methods: {
    formatTime(val) {
      const d = new Date(val)
      const now = new Date()
      const diff = (now - d) / 1000
      if (diff < 60) return '刚刚'
      if (diff < 3600) return `${Math.floor(diff / 60)}分钟前`
      if (diff < 86400) return `${Math.floor(diff / 3600)}小时前`
      return d.toLocaleDateString('zh-CN', { month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit' })
    },
    handelallread() {
      const idlist = this.messages.filter(m => !m.IsRead).map(m => m.ID)
      if (idlist.length) this.handleRead(idlist)
    },
    handleRead(idlist) {
      this.tableloading = true
      this.$store.dispatch('user/readmessage', { idlist }).then(() => {
        this.getmessagelist()
      })
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this.getmessagelist()
    },
    getmessagelist() {
      this.tableloading = true
      this.$store.dispatch('user/getInfo')
      this.$store.dispatch('user/getmymessage', {
        page: this.currentPage,
        pageSize: this.pageSize
      }).then(res => {
        this.messages = res.messages
        this.total = res.total
        this.tableloading = false
      })
    }
  }
}
</script>

<style scoped>
.msg-panel {
  display: flex;
  flex-direction: column;
  max-height: 480px;
}

.msg-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 14px 16px 12px;
  border-bottom: 1px solid #f0f0f0;
  flex-shrink: 0;
}
.msg-title {
  font-size: 14px;
  font-weight: 600;
  color: #1a1a1a;
}
.msg-header-actions {
  display: flex;
  gap: 4px;
}
.action-btn {
  font-size: 12px;
  color: #888;
  padding: 0 4px;
}
.action-btn:hover { color: #409EFF; }

.msg-list {
  flex: 1;
  overflow-y: auto;
  min-height: 100px;
}
.msg-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 40px 0;
  color: #bbb;
  font-size: 13px;
  gap: 8px;
}

.msg-item {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  padding: 12px 16px;
  border-bottom: 1px solid #f8f8f8;
  cursor: pointer;
  transition: background 0.15s;
  position: relative;
}
.msg-item:hover { background: #fafafa; }
.msg-item.unread { background: #fffbf5; }
.msg-item.unread:hover { background: #fff7ed; }

.msg-dot {
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background: #f5a623;
  flex-shrink: 0;
  margin-top: 5px;
}

.msg-content {
  flex: 1;
  min-width: 0;
}
.msg-text {
  font-size: 13px;
  color: #333;
  line-height: 1.5;
  margin: 0 0 4px;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}
.msg-time {
  font-size: 11px;
  color: #bbb;
}

.msg-tag {
  flex-shrink: 0;
  border-radius: 4px;
  font-size: 11px;
}

.msg-footer {
  display: flex;
  justify-content: center;
  padding: 10px 0 8px;
  border-top: 1px solid #f0f0f0;
  flex-shrink: 0;
}
.msg-footer .el-pagination {
  font-size: 12px;
}
</style>